<template>
  <v-card
    flat
    class="position-relative pointer-on-hover"
    :class="{ 'border-nitro' : module.selected }"
    outlined
    @click="$emit( module.selected ? 'remove' : 'add' , module)"
  >
    <v-tooltip
      v-if="module.trail_weight == 10"
      top
    >
      <template #activator="{ on, attrs }">
        <v-icon
          color="nitro"
          class="position-absolute ml-2 mt-2"
          v-bind="attrs"
          v-on="on"
        >
          fas fa-star
        </v-icon>
      </template>
      <span>Esse módulo é alinhado com a sua trilha do conhecimento! </span>
    </v-tooltip>

    <div class="card-module-header header p-4 border-bottom">
      <p class="mb-0 text-center font-weight-bolder">
        {{ module.subject_name }}
      </p>
      <p class="text-center mb-0">
        {{ module.name }}
      </p>
    </div>
    <div class="px-md-3 p-3">
      <div class="p-3 p-md-4 bg-light">
        <div class="d-flex justify-content-between my-1 align-items-center">
          <div class="py-2 font-weight-bolder">
            Incidência Enem
          </div>
          <Progress :completed="getBars(module.enem_weight)" />
        </div>
        <div class="d-flex justify-content-between my-1 align-items-center">
          <div class="py-2 font-weight-bolder">
            Impacto na nota
          </div>
          <Progress :completed="getBars(module.subtopic_weight)" />
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import Progress from "@/common/components/Progress.vue"
export default {
  components:{
    Progress,
  },
  props: {
    module: {
      type: Object,
      required: true,
    },
  },
  methods:{
    getBars(value){
      const result = Math.round(((value/2 + 0.5) * 10));
      return result > 10 ? 10: result;
    }
  },
}
</script>

<style lang="scss" scoped>
.card-module-header {
  height:100px
}
</style>
